import React from "react";
import { HOME, USER_MANAGEMENT, ROLE_MANAGEMENT } from "./path";

const Home = React.lazy(() => import("views/Home"));
const Atal = React.lazy(() => import("views/Atal"));
const UserManagement = React.lazy(() => import("views/UserManagement"));
const RoleManagement = React.lazy(() => import("views/RoleManagement"));

const ROUTES = [
	{
		path: HOME,
		component: Home,
	},
	{
		path: 'atal',
		component: Atal,
	},
	{
		path: `${USER_MANAGEMENT}/*`,
		component: UserManagement,
	},
	{
		path: `${ROLE_MANAGEMENT}/*`,
		component: RoleManagement,
	},
]

export default ROUTES;
